require('./lbaLoader.scss');

const $inject = [];
const lbaLoader = function () {
  return {
    restrict: 'A',
    scope:{},
    bindToController: true,
    controller: 'lbaLoaderCtrl',
    controllerAs: 'vm',
    template: require('./lbaLoader.html')
  }
};

lbaLoader.$inject = $inject;

export default lbaLoader;


// WEBPACK FOOTER //
// ./src/components/lbaLoader/lbaLoaderDir.js